export enum VoyageRouteView {
  list = 'list',
  card = 'card',
}
